import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ClerkSignInPage } from '@/components/auth/ClerkAuthPages';

export const Route = createFileRoute('/auth/sign-in')({
  component: SignInLayout,
});

/** Always mount SignIn in the layout so splat children cannot remount it. */
function SignInLayout() {
  return (
    <>
      <ClerkSignInPage />
      <Outlet />
    </>
  );
}
